import React, { useState } from 'react'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { PageSection } from '../../../theme/components/PageSection'
import { StyledIconButton } from '../../../theme/components/StyledIconButton'
import { useKlantAdditioneleVragen } from '../../klant/hooks/useKlantAdditioneleVragen'
import { AansluitObject } from '../../projecten/components/AansluitObject'
import type { Project } from '../types/Project'

import { VraagAntwoord } from './VraagAntwoord'

const headerCells = [
  { id: 'disciplines', numeric: false, label: 'Aangevraagde disciplines' },
  { id: 'objectID', numeric: true, label: 'Object id' },
  { id: 'type', numeric: false, label: 'Object type' },
  { id: 'adres', numeric: false, label: 'Adres' },
  { id: 'statusText', numeric: false, label: 'Processtap', fixed: 150 },
  { id: 'opties', numeric: false, label: '', fixed: 50 },
]

interface Props {
  project: Project
  showVraagAntwoord: boolean
}

export const Objecten = ({ project, showVraagAntwoord }: Props) => {
  const [showBeantwoordeVragen, setShowBeantwoordeVragen] = useState(false)
  const { data: beantwoordeVragen } = useKlantAdditioneleVragen({
    id: project.aanvraagID,
  })

  const aansluitObjecten = project.aansluitObjecten || []
  const additioneleVragenExists =
    beantwoordeVragen.length > 0 &&
    beantwoordeVragen[0].additioneleVragen.length > 0

  return (
    <PageSection
      heading="Objecten"
      id="objecten"
      actions={
        <>
          {showVraagAntwoord && additioneleVragenExists && (
            <StyledIconButton
              title="Toon beantwoorde vragen"
              onClick={() => setShowBeantwoordeVragen(!showBeantwoordeVragen)}
              icon={<QuestionAnswerIcon />}
            />
          )}
        </>
      }
    >
      <Box>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Alle objecten ({aansluitObjecten.length})</Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ padding: 0 }}>
            <Table
              sx={{ padding: 0, backgroundColor: '#f7f7f7' }}
              size="medium"
            >
              <TableHead>
                <TableRow>
                  {headerCells.map((headerCell) => (
                    <TableCell
                      key={headerCell.id}
                      sx={{
                        width: headerCell.fixed,
                      }}
                    >
                      {headerCell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {aansluitObjecten.map((aansluitObject) => (
                  <React.Fragment
                    key={`${project.aanvraagID}${aansluitObject.objectID}`}
                  >
                    <AansluitObject
                      project={project}
                      aansluitObject={aansluitObject}
                    />
                    {showVraagAntwoord &&
                      showBeantwoordeVragen &&
                      additioneleVragenExists &&
                      aansluitObject.produkten.map((product) => (
                        <VraagAntwoord
                          key={product.disciplineID}
                          product={product}
                          beantwoordeVragen={beantwoordeVragen}
                        />
                      ))}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>
      </Box>
    </PageSection>
  )
}
